import React, { useState, useEffect } from 'react';
import Navbar from '../../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import AboveTarget from './srcs/AboveTarget.png';
import BelowTarget from './srcs/BelowTarget.png';
import NeedImprovement from './srcs/NeedImprovement.png';
import Target from './srcs/Target.png';
import Navbar_two from '../../Navbar/Navbar2';

export default function SeeTheAnswerTable() {
  const [results, setResults] = useState([]);
  const [selectedOption, setSelectedOption] = useState('all');
  const [courseName, setCourseName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedResults = JSON.parse(sessionStorage.getItem('results'));
    if (storedResults) {
      setResults(storedResults);
    }
    
    // Get course name from URL or localStorage
    const url = window.location.href;
    const referrer = document.referrer;
    const parts = referrer.split('/');
    const courseFromUrl = parts[parts.length - 1];
    
    // Also check localStorage for CourseInfo
    const courseInfo = JSON.parse(localStorage.getItem("CourseInfo"));
    const courseNameFromStorage = courseInfo?.name || courseFromUrl || '';
    setCourseName(courseNameFromStorage);
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  // Kill Mistakes handler - start exam with only wrong answers
  const handleKillMistakes = () => {
    // Get wrong answers from results
    const wrongResults = results.filter(result => result.is_correct === "not Correct");
    
    // Get the original questions data
    const originalQuestions = JSON.parse(sessionStorage.getItem('originalQuestions'));
    
    if (originalQuestions && wrongResults.length > 0) {
      // Filter original questions to only include the ones that were answered incorrectly
      const wrongQuestionTexts = wrongResults.map(r => r.question);
      const filteredQuestions = originalQuestions.questions.filter(q => 
        wrongQuestionTexts.includes(q.text)
      );
      
      // Create a new questions object with only wrong questions
      const killMistakesQuestions = {
        ...originalQuestions,
        questions: filteredQuestions,
        name: `${originalQuestions.name || 'Exam'} - Kill Mistakes`
      };
      
      // Store the filtered questions for the Kill Mistakes exam
      sessionStorage.setItem('killMistakesQuestions', JSON.stringify(killMistakesQuestions));
      sessionStorage.setItem('isKillMistakesMode', 'true');
      
      // Clear previous user answers for wrong questions
      wrongQuestionTexts.forEach(questionText => {
        sessionStorage.removeItem(questionText);
      });
      
      // Navigate back to exam
      navigate(-1);
    }
  };

  if (results.length === 0) {
    return <p>No results to display</p>;
  }

  // Check if current course is PMP
  const isPMP = courseName.toUpperCase() === 'PMP';

  const scoreChecking = (score) => {
    let result;
    switch (true) {
      case score < 40:
        result = 'NeedImprovement';
        break;
      case score < 74:
        result = 'BelowTarget';
        break;
      case score < 85:
        result = 'Target';
        break;
      case score > 85:
        result = 'AboveTarget';
        break;
      default:
        result = 'Outstanding';
    }
    return result;
  };

  // Get status for non-PMP courses
  const getStatusCategory = (percentage) => {
    if (percentage < 75) return 'below';
    if (percentage === 75) return 'on';
    return 'above';
  };

  const totalQuestions = results.length;
  const correctAnswersCount = results.reduce((count, result) => {
    if (result.is_correct === "Correct") {
      return count + 1;
    }
    return count;
  }, 0);

  
  const correctPercentage = Math.round((correctAnswersCount / totalQuestions) * 100);

  const scoreResult = scoreChecking(correctPercentage);
  const statusCategory = getStatusCategory(correctPercentage);

  let scoreImage;
  switch (scoreResult) {
    case 'NeedImprovement':
      scoreImage = NeedImprovement;
      break;
    case 'BelowTarget':
      scoreImage = BelowTarget;
      break;
    case 'Target':
      scoreImage = Target;
      break;
    case 'AboveTarget':
      scoreImage = AboveTarget;
      break;
    default:
      scoreImage = 'DefaultImage';
  }

  const filteredResults =
    selectedOption === 'correct'
      ? results.filter((result) => result.is_correct === "Correct")
      : selectedOption === 'wrong'
      ? results.filter((result) => result.is_correct === "not Correct")
      : results;

  // Status card styles
  const cardBaseStyle = {
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    minWidth: '150px',
    flex: '1',
    margin: '0 10px',
    transition: 'transform 0.3s, box-shadow 0.3s'
  };

  const getCardStyle = (category) => {
    const isActive = statusCategory === category;
    const colors = {
      below: { bg: '#dc3545', border: '#c82333' },
      on: { bg: '#ffc107', border: '#e0a800' },
      above: { bg: '#28a745', border: '#1e7e34' }
    };
    
    return {
      ...cardBaseStyle,
      backgroundColor: isActive ? colors[category].bg : '#2d2d2d',
      border: isActive ? `3px solid ${colors[category].border}` : '2px solid #444',
      color: isActive ? '#fff' : '#888',
      transform: isActive ? 'scale(1.05)' : 'scale(1)',
      boxShadow: isActive ? '0 8px 20px rgba(0,0,0,0.3)' : 'none'
    };
  };

  return (
    
    <>
      <Navbar_two />
      <h2 className="text-center my-2">Result</h2>
      <h4 className="text-center">
        Percentage of correct answers: <span className="fw-bold">{correctPercentage}%</span>
      </h4>

      {isPMP ? (
        // PMP Course: Show the existing image
        <div className="container my-5 d-flex justify-content-center">
          <img src={scoreImage} width={'100%'} style={{ maxWidth: '700px' }} className="result-image" alt="Score Result" />
        </div>
      ) : (
        // Non-PMP Course: Show status cards
        <div className="container my-5">
          <div className="d-flex justify-content-center flex-wrap" style={{ gap: '15px' }}>
            <div style={getCardStyle('below')}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem' }}>Below Target</h4>
              <p style={{ margin: 0, fontSize: '0.9rem' }}>0% - 74%</p>
              {statusCategory === 'below' && <span style={{ fontSize: '1.5rem' }}>⚠️</span>}
            </div>
            <div style={getCardStyle('on')}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem' }}>On Target</h4>
              <p style={{ margin: 0, fontSize: '0.9rem' }}>75%</p>
              {statusCategory === 'on' && <span style={{ fontSize: '1.5rem' }}>📊</span>}
            </div>
            <div style={getCardStyle('above')}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem' }}>Above Target</h4>
              <p style={{ margin: 0, fontSize: '0.9rem' }}>&gt; 75%</p>
              {statusCategory === 'above' && <span style={{ fontSize: '1.5rem' }}>🎯</span>}
            </div>
          </div>
        </div>
      )}

      <hr />
      <h3 className="text-center">Your Answers</h3>

      <br />
      <div className="d-flex justify-content-center mb-3">
        <div className="form-group col-md-4">
          <label htmlFor="answerFilter">Filter by Answer Type:</label>
          <select
            className="form-select search-result bg-dark text-light"
            id="answerFilter"
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <option value="all">All</option>
            <option value="correct">Correct</option>
            <option value="wrong">Wrong</option>
          </select>
        </div>
      </div>

      <div className="table-responsive-md">
        <div className='table-parent'>
          <table className="table container text-left my-5 table-bordered">
            <thead className="text-dark">
              <tr className="table-dark">
                <th scope="col">Question</th>
                <th scope="col">User_Answer</th>
                <th scope="col">Correct_Answer</th>
                <th scope="col">isCorrect</th>
                <th scope="col">Explanation</th>
              </tr>
            </thead>
            <tbody className="text-light">
              {filteredResults.map((result, index) => {


                return (
                  <tr key={index} className={result.is_correct === 'Correct' ? 'table-success' : 'table-danger'}>
                    <td>{result.question}</td>
                    <td>{`${result.user_answer} ,  `}</td>
                    <td>{`${result.correctAnswer} , `}</td>
                    <td>{result.is_correct}</td>
                    <td>{result.explanation}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Action Buttons Section */}
      <div className="container my-5">
        <div className="d-flex flex-wrap justify-content-center align-items-center gap-4">
          <button 
            type="button" 
            onClick={handleBackClick} 
            className="btn text-dark btn-outline-light btn-lg px-4 py-3"
            style={{
              borderRadius: '12px',
              minWidth: '180px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
          >
            🔄 Redo The Exam
          </button>
          
          {/* Kill Mistakes Button - only show if there are wrong answers */}
          {results.some(result => result.is_correct === "not Correct") && (
            <button 
              type="button" 
              onClick={handleKillMistakes} 
              className="btn btn-lg px-4 py-3"
              style={{
                borderRadius: '12px',
                minWidth: '200px',
                fontWeight: '600',
                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                border: 'none',
                color: '#fff',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(220, 53, 69, 0.4)'
              }}
            >
              🎯 Blind Spots Exam ({results.filter(r => r.is_correct === "not Correct").length})
            </button>
          )}
        </div>
      </div>
    </>
  );
}